import { Component, Input, OnInit } from '@angular/core';
import { Common } from 'src/app/common';

@Component({
  selector: 'app-bpay-summary',
  templateUrl: './bpay-summary.component.html',
  styleUrls: ['./bpay-summary.component.scss']
})
export class BpaySummaryComponent implements OnInit {
  @Input() summary?: any;

  constructor() { }

  ngOnInit(): void {
  }

  public getPaymentAmount(): string {
    return `${Common.getFormattedCurrencyValue(this.summary?.amount ?? 0, false, false)} ${this.summary?.currency ?? ''}`;
  }
}
